import type { ReactNode } from "react";

import { PeekProvider } from "./Peek";
import { ToastProvider } from "./Toast";
import { TooltipProvider } from "./Tooltip";

/**
 * Everything the overlay layer needs, mounted once.
 *
 * Put this immediately inside the auth gate and outside the shell, so a toast
 * survives a route change and the peek can outlive the surface that opened it.
 *
 * Order is deliberate rather than incidental:
 *
 * - the tooltip provider is outermost because it holds no state of its own,
 *   only the shared open/close delay;
 * - toasts wrap the peek so a peek can report a failed save as a toast;
 * - the peek is innermost so it is the closest provider to the features that
 *   open it.
 *
 * Stacking is *not* set by this order — it is set by the `LAYER` constants in
 * `surface.ts`, where toast sits above dialog sits above peek.
 */
export function OverlayProvider({ children }: { children: ReactNode }) {
  return (
    <TooltipProvider>
      <ToastProvider>
        <PeekProvider>{children}</PeekProvider>
      </ToastProvider>
    </TooltipProvider>
  );
}
